var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-result", {
        attrs: {
          status: "404",
          title: "404",
          "sub-title": "Sorry, the page you visited does not exist."
        },
        scopedSlots: _vm._u([
          {
            key: "extra",
            fn: function() {
              return [
                _c(
                  "router-link",
                  { attrs: { to: "/" } },
                  [
                    _c("a-button", { attrs: { type: "primary" } }, [
                      _vm._v(" Back to Dashboard ")
                    ])
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }